var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 13.6946C4.33333 12.462 4.34179 12.0413 4.44179 11.664C4.5379 11.3014 4.69607 10.9581 4.90929 10.6494C5.13115 10.3282 5.44543 10.0485 6.38247 9.24763L9.19913 6.84022C10.0112 6.14615 10.5749 5.66527 11.0459 5.32089C11.5059 4.98453 11.8137 4.82729 12.0928 4.74613C12.6853 4.5739 13.3146 4.5739 13.9072 4.74613C14.1863 4.82729 14.4941 4.98453 14.9541 5.32089C15.4251 5.66527 15.9888 6.14615 16.8009 6.84022L19.6175 9.24762C20.5546 10.0485 20.8688 10.3282 21.0907 10.6494C21.3039 10.9581 21.4621 11.3014 21.5582 11.664C21.6582 12.0413 21.6667 12.462 21.6667 13.6946V16.8998C21.6667 18.1312 21.6658 18.9895 21.6112 19.6577C21.5577 20.3133 21.4578 20.69 21.3124 20.9753C21.0008 21.5868 20.5037 22.084 19.8921 22.3956C19.6068 22.541 19.2302 22.6408 18.5746 22.6944C17.9063 22.749 17.048 22.7498 15.8167 22.7498H10.1833C8.95201 22.7498 8.09367 22.749 7.42542 22.6944C6.76983 22.6408 6.39317 22.541 6.10786 22.3956L5.61604 23.3609L6.10786 22.3956C5.49634 22.084 4.99915 21.5868 4.68756 20.9753C4.54219 20.69 4.44234 20.3133 4.38877 19.6577C4.33418 18.9895 4.33333 18.1312 4.33333 16.8998V13.6946Z",
    stroke: "#AFAFAF",
    strokeWidth: 2.16667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8f6e78ff7835bb3eb1d601d2d196ce36.svg";
export { ForwardRef as ReactComponent };